import Login                from '../views/Login.vue'
//import Store                from './../views/Store.vue'
import Home                 from './../views/Home.vue'
import changeUserPassword   from '@/components/login/ChangePassWord.vue'
const routes = [
    {
        path        : '/login',
        name        : 'Login',
        component   : Login,
        meta        : {menu:''},
         
    },
    /*
    {
        path        : '/store',
        name        : 'Log2',
        component   : Store,
        meta        : {menu:''},
         
    },
    */
    {
        path        : '/home',
        name        : 'Log3',
        component   : Home,
        meta        : {menu:''},
         
    },
    {
        path        : '/password',
        name        : 'password',
        component   : changeUserPassword,
        meta        : {menu:''},
    
    }

    
    
    
]
export default routes